//loader
export const LOADER = {
    LOADER_TRIGGER: "loader-trigger",
    LOADER_SHOW: "loader-show",
  };

//Admin Get Profile
export const GET_PROFILE = "GET_PROFILE";
export const GET_PROFILE_REQUESTED = "GET_PROFILE_REQUESTED";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAILED = "GET_PROFILE_FAILED";

//Update Profile Action
export const GET_UPDATEPROFILE = "GET_UPDATEPROFILE";
export const GET_UPDATEPROFILE_REQUESTED = "GET_UPDATEPROFILE_REQUESTED";
export const GET_UPDATEPROFILE_SUCCESS = "GET_UPDATEPROFILE_SUCCESS";
export const GET_UPDATEPROFILE_FAILED = "GET_UPDATEPROFILE_FAILED";

//Login Action
export const GET_LOGIN = "GET_LOGIN";
export const GET_LOGIN_REQUESTED = "GET_LOGIN_REQUESTED";
export const GET_LOGIN_SUCCESS = "GET_LOGIN_SUCCESS";
export const GET_LOGIN_FAILED = "GET_LOGIN_FAILED";

//Otp Action
export const GET_OTP = "GET_OTP";
export const GET_OTP_REQUESTED = "GET_OTP_REQUESTED";
export const GET_OTP_SUCCESS = "GET_OTP_SUCCESS";
export const GET_OTP_FAILED = "GET_OTP_FAILED";

//Vendor Action
export const GET_VENDOR = "GET_VENDOR";
export const GET_VENDOR_REQUESTED = "GET_VENDOR_REQUESTED";
export const GET_VENDOR_SUCCESS = "GET_VENDOR_SUCCESS";
export const GET_VENDOR_FAILED = "GET_VENDOR_FAILED";

//Create Vendor Action
export const GET_ADDVENDOR = "GET_ADDVENDOR";
export const GET_ADDVENDOR_REQUESTED = "GET_ADDVENDOR_REQUESTED";
export const GET_ADDVENDOR_SUCCESS = "GET_ADDVENDOR_SUCCESS";
export const GET_ADDVENDOR_FAILED = "GET_ADDVENDOR_FAILED";

//Update Vendor Action
export const GET_UPDATEVENDOR = "GET_UPDATEVENDOR";
export const GET_UPDATEVENDOR_REQUESTED = "GET_UPDATEVENDOR_REQUESTED";
export const GET_UPDATEVENDOR_SUCCESS = "GET_UPDATEVENDOR_SUCCESS";
export const GET_UPDATEVENDOR_FAILED = "GET_UPDATEVENDOR_FAILED";

//Create Sub-Vendor Action
export const GET_SUBADDVENDOR = "GET_SUBADDVENDOR";
export const GET_SUBADDVENDOR_REQUESTED = "GET_SUBADDVENDOR_REQUESTED";
export const GET_SUBADDVENDOR_SUCCESS = "GET_SUBADDVENDOR_SUCCESS";
export const GET_SUBADDVENDOR_FAILED = "GET_SUBADDVENDOR_FAILED";

//Sub-Vendor Action
export const GET_SUBVENDOR = "GET_SUBVENDOR";
export const GET_SUBVENDOR_REQUESTED = "GET_SUBVENDOR_REQUESTED";
export const GET_SUBVENDOR_SUCCESS = "GET_SUBVENDOR_SUCCESS";
export const GET_SUBVENDOR_FAILED = "GET_SUBVENDOR_FAILED";


//Update Sub-Vendor Action
export const UPDATE_SUBADDVENDOR = "UPDATE_SUBADDVENDOR";
export const UPDATE_SUBADDVENDOR_REQUESTED = "UPDATE_SUBADDVENDOR_REQUESTED";
export const UPDATE_SUBADDVENDOR_SUCCESS = "UPDATE_SUBADDVENDOR_SUCCESS";
export const UPDATE_SUBADDVENDOR_FAILED = "UPDATE_SUBADDVENDOR_FAILED";

//More Details Sub-Vendor Action
export const GET_DETAILSUBVENDOR = "GET_DETAILSUBVENDOR";
export const GET_DETAILSUBVENDOR_REQUESTED = "GET_DETAILSUBVENDOR_REQUESTED";
export const GET_DETAILSUBVENDOR_SUCCESS = "GET_DETAILSUBVENDOR_SUCCESS";
export const GET_DETAILSUBVENDOR_FAILED = "GET_DETAILSUBVENDOR_FAILED";

//Compliance Action
export const GET_COMPLIANCE = "GET_COMPLIANCE";
export const GET_COMPLIANCE_REQUESTED = "GET_COMPLIANCE_REQUESTED";
export const GET_COMPLIANCE_SUCCESS = "GET_COMPLIANCE_SUCCESS";
export const GET_COMPLIANCE_FAILED = "GET_COMPLIANCE_FAILED";

//Config Compliance Action
export const GET_CONFIGCOMPLIANCE = "GET_CONFIGCOMPLIANCE";
export const GET_CONFIGCOMPLIANCE_REQUESTED = "GET_CONFIGCOMPLIANCE_REQUESTED";
export const GET_CONFIGCOMPLIANCE_SUCCESS = "GET_CONFIGCOMPLIANCE_SUCCESS";
export const GET_CONFIGCOMPLIANCE_FAILED = "GET_CONFIGCOMPLIANCE_FAILED";

//Approve Reject Compliance Action
export const GET_APPROVECOMPLIANCE = "GET_APPROVECOMPLIANCE";
export const GET_APPROVECOMPLIANCE_REQUESTED = "GET_APPROVECOMPLIANCE_REQUESTED";
export const GET_APPROVECOMPLIANCE_SUCCESS = "GET_APPROVECOMPLIANCE_SUCCESS";
export const GET_APPROVECOMPLIANCE_FAILED = "GET_APPROVECOMPLIANCE_FAILED";

//Create Config Compliance Action
export const GET_ADDCOMPLIANCE = "GET_ADDCOMPLIANCE";
export const GET_ADDCOMPLIANCE_REQUESTED = "GET_ADDCOMPLIANCE_REQUESTED";
export const GET_ADDCOMPLIANCE_SUCCESS = "GET_ADDCOMPLIANCE_SUCCESS";
export const GET_ADDCOMPLIANCE_FAILED = "GET_ADDCOMPLIANCE_FAILED";

//Update Config Compliance Action
export const GET_UPDATECOMPLIANCE = "GET_UPDATECOMPLIANCE";
export const GET_UPDATECOMPLIANCE_REQUESTED = "GET_UPDATECOMPLIANCE_REQUESTED";
export const GET_UPDATECOMPLIANCE_SUCCESS = "GET_UPDATECOMPLIANCE_SUCCESS";
export const GET_UPDATECOMPLIANCE_FAILED = "GET_UPDATECOMPLIANCE_FAILED";

//Onboard-Compliance Action
export const GET_ONBOARD_COMPLIANCE = "GET_ONBOARD_COMPLIANCE";
export const GET_ONBOARD_COMPLIANCE_REQUESTED = "GET_ONBOARD_COMPLIANCE_REQUESTED";
export const GET_ONBOARD_COMPLIANCE_SUCCESS = "GET_ONBOARD_COMPLIANCE_SUCCESS";
export const GET_ONBOARD_COMPLIANCE_FAILED = "GET_ONBOARD_COMPLIANCE_FAILED";

//Create Onboard-Compliance Action
export const GET_ADDONBOARD_COMPLIANCE = "GET_ADDONBOARD_COMPLIANCE";
export const GET_ADDONBOARD_COMPLIANCE_REQUESTED = "GET_ADDONBOARD_COMPLIANCE_REQUESTED";
export const GET_ADDONBOARD_COMPLIANCE_SUCCESS = "GET_ADDONBOARD_COMPLIANCE_SUCCESS";
export const GET_ADDONBOARD_COMPLIANCE_FAILED = "GET_ADDONBOARD_COMPLIANCE_FAILED";

//Driver Action
export const GET_DRIVER = "GET_DRIVER";
export const GET_DRIVER_REQUESTED = "GET_DRIVER_REQUESTED";
export const GET_DRIVER_SUCCESS = "GET_DRIVER_SUCCESS";
export const GET_DRIVER_FAILED = "GET_DRIVER_FAILED";

//Create Driver Action
export const GET_ADDDRIVER = "GET_ADDDRIVER";
export const GET_ADDDRIVER_REQUESTED = "GET_ADDDRIVER_REQUESTED";
export const GET_ADDDRIVER_SUCCESS = "GET_ADDDRIVER_SUCCESS";
export const GET_ADDDRIVER_FAILED = "GET_ADDDRIVER_FAILED";

//Update Driver Action
export const GET_UPDATEDRIVER = "GET_UPDATEDRIVER";
export const GET_UPDATEDRIVER_REQUESTED = "GET_UPDATEDRIVER_REQUESTED";
export const GET_UPDATEDRIVER_SUCCESS = "GET_UPDATEDRIVER_SUCCESS";
export const GET_UPDATEDRIVER_FAILED = "GET_UPDATEDRIVER_FAILED";

//FAQ Action
export const GET_FAQ = "GET_FAQ";
export const GET_FAQ_REQUESTED = "GET_FAQ_REQUESTED";
export const GET_FAQ_SUCCESS = "GET_FAQ_SUCCESS";
export const GET_FAQ_FAILED = "GET_FAQ_FAILED";

//Create FAQ Action
export const GET_ADDFAQ = "GET_ADDFAQ";
export const GET_ADDFAQ_REQUESTED = "GET_ADDFAQ_REQUESTED";
export const GET_ADDFAQ_SUCCESS = "GET_ADDFAQ_SUCCESS";
export const GET_ADDFAQ_FAILED = "GET_ADDFAQ_FAILED";

//Update FAQ Action
export const GET_UPDATEFAQ = "GET_UPDATEFAQ";
export const GET_UPDATEFAQ_REQUESTED = "GET_UPDATEFAQ_REQUESTED";
export const GET_UPDATEFAQ_SUCCESS = "GET_UPDATEFAQ_SUCCESS";
export const GET_UPDATEFAQ_FAILED = "GET_UPDATEFAQ_FAILED";

//Delete FAQ Action
export const GET_DELETEFAQ = "GET_DELETEFAQ";
export const GET_DELETEFAQ_REQUESTED = "GET_DELETEFAQ_REQUESTED";
export const GET_DELETEFAQ_SUCCESS = "GET_DELETEFAQ_SUCCESS";
export const GET_DELETEFAQ_FAILED = "GET_DELETEFAQ_FAILED";

//Car Action
export const GET_CAR = "GET_CAR";
export const GET_CAR_REQUESTED = "GET_CAR_REQUESTED";
export const GET_CAR_SUCCESS = "GET_CAR_SUCCESS";
export const GET_CAR_FAILED = "GET_CAR_FAILED";

//Create Car Action
export const GET_ADDCAR = "GET_ADDCAR";
export const GET_ADDCAR_REQUESTED = "GET_ADDCAR_REQUESTED";
export const GET_ADDCAR_SUCCESS = "GET_ADDCAR_SUCCESS";
export const GET_ADDCAR_FAILED = "GET_ADDCAR_FAILED";

//Update Car Action
export const GET_UPDATECAR = "GET_UPDATECAR";
export const GET_UPDATECAR_REQUESTED = "GET_UPDATECAR_REQUESTED";
export const GET_UPDATECAR_SUCCESS = "GET_UPDATECAR_SUCCESS";
export const GET_UPDATECAR_FAILED = "GET_UPDATECAR_FAILED";

//Delete Car Action
export const GET_DELETECAR = "GET_DELETECAR";
export const GET_DELETECAR_REQUESTED = "GET_DELETECAR_REQUESTED";
export const GET_DELETECAR_SUCCESS = "GET_DELETECAR_SUCCESS";
export const GET_DELETECAR_FAILED = "GET_DELETECAR_FAILED";

//Facilities Action
export const GET_FACILITIES = "GET_FACILITIES";
export const GET_FACILITIES_REQUESTED = "GET_FACILITIES_REQUESTED";
export const GET_FACILITIES_SUCCESS = "GET_FACILITIES_SUCCESS";
export const GET_FACILITIES_FAILED = "GET_FACILITIES_FAILED";

//Tag Action
export const GET_TAG = "GET_TAG";
export const GET_TAG_REQUESTED = "GET_TAG_REQUESTED";
export const GET_TAG_SUCCESS = "GET_TAG_SUCCESS";
export const GET_TAG_FAILED = "GET_TAG_FAILED";

//Create Tag Action
export const GET_ADDTAG = "GET_ADDTAG";
export const GET_ADDTAG_REQUESTED = "GET_ADDTAG_REQUESTED";
export const GET_ADDTAG_SUCCESS = "GET_ADDTAG_SUCCESS";
export const GET_ADDTAG_FAILED = "GET_ADDTAG_FAILED";

//Update Tag Action
export const GET_UPDATETAG = "GET_UPDATETAG";
export const GET_UPDATETAG_REQUESTED = "GET_UPDATETAG_REQUESTED";
export const GET_UPDATETAG_SUCCESS = "GET_UPDATETAG_SUCCESS";
export const GET_UPDATETAG_FAILED = "GET_UPDATETAG_FAILED";

//Rating Action
export const GET_RATING = "GET_RATING";
export const GET_RATING_REQUESTED = "GET_RATING_REQUESTED";
export const GET_RATING_SUCCESS = "GET_RATING_SUCCESS";
export const GET_RATING_FAILED = "GET_RATING_FAILED";

// Dashboard Ride Details
export const GET_RIDE = "GET_RIDE";
export const GET_RIDE_REQUESTED = "GET_RIDE_REQUESTED";
export const GET_RIDE_SUCCESS = "GET_RIDE_SUCCESS";
export const GET_RIDE_FAILED = "GET_RIDE_FAILED";

// Dashboard Total Registration
export const GET_TOTALREGISTRATION = "GET_TOTALREGISTRATION";
export const GET_TOTALREGISTRATION_REQUESTED = "GET_TOTALREGISTRATION_REQUESTED";
export const GET_TOTALREGISTRATION_SUCCESS = "GET_TOTALREGISTRATION_SUCCESS";
export const GET_TOTALREGISTRATION_FAILED = "GET_TOTALREGISTRATION_FAILED";

// Dashboard Daily Customer
export const GET_DAILYCUSTOMER = "GET_DAILYCUSTOMER";
export const GET_DAILYCUSTOMER_REQUESTED = "GET_DAILYCUSTOMER_REQUESTED";
export const GET_DAILYCUSTOMER_SUCCESS = "GET_DAILYCUSTOMER_SUCCESS";
export const GET_DAILYCUSTOMER_FAILED = "GET_DAILYCUSTOMER_FAILED";

// Dashboard Daily Ride
export const GET_RIDEANALYTIC = "GET_RIDEANALYTIC";
export const GET_RIDEANALYTIC_REQUESTED = "GET_RIDEANALYTIC_REQUESTED";
export const GET_RIDEANALYTIC_SUCCESS = "GET_RIDEANALYTIC_SUCCESS";
export const GET_RIDEANALYTIC_FAILED = "GET_RIDEANALYTIC_FAILED";

// Customer Action
export const GET_CUSTOMER = "GET_CUSTOMER";
export const GET_CUSTOMER_REQUESTED = "GET_CUSTOMER_REQUESTED";
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS";
export const GET_CUSTOMER_FAILED = "GET_CUSTOMER_FAILED";

// Update Customer Action
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const UPDATE_CUSTOMER_REQUESTED = "UPDATE_CUSTOMER_REQUESTED";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_FAILED = "UPDATE_CUSTOMER_FAILED";

//Customer Matrix Action
export const GET_MATRIXCUSTOMER = "GET_MATRIXCUSTOMER";
export const GET_MATRIXCUSTOMER_REQUESTED = "GET_MATRIXCUSTOMER_REQUESTED";
export const GET_MATRIXCUSTOMER_SUCCESS = "GET_MATRIXCUSTOMER_SUCCESS";
export const GET_MATRIXCUSTOMER_FAILED = "GET_MATRIXCUSTOMER_FAILED";

//Customer Ticket Action
export const GET_TICKETCUSTOMER = "GET_TICKETCUSTOMER";
export const GET_TICKETCUSTOMER_REQUESTED = "GET_TICKETCUSTOMER_REQUESTED";
export const GET_TICKETCUSTOMER_SUCCESS = "GET_TICKETCUSTOMER_SUCCESS";
export const GET_TICKETCUSTOMER_FAILED = "GET_TICKETCUSTOMER_FAILED";

//Driver Matrix Action
export const GET_MATRIXDRIVER = "GET_MATRIXDRIVER";
export const GET_MATRIXDRIVER_REQUESTED = "GET_MATRIXDRIVER_REQUESTED";
export const GET_MATRIXDRIVER_SUCCESS = "GET_MATRIXDRIVER_SUCCESS";
export const GET_MATRIXDRIVER_FAILED = "GET_MATRIXDRIVER_FAILED";

//Driver Ticket Action
export const GET_TICKETDRIVER = "GET_TICKETDRIVER";
export const GET_TICKETDRIVER_REQUESTED = "GET_TICKETDRIVER_REQUESTED";
export const GET_TICKETDRIVER_SUCCESS = "GET_TICKETDRIVER_SUCCESS";
export const GET_TICKETDRIVER_FAILED = "GET_TICKETDRIVER_FAILED";

//Driver More Details Action
export const GET_MOREDRIVER = "GET_MOREDRIVER";
export const GET_MOREDRIVER_REQUESTED = "GET_MOREDRIVER_REQUESTED";
export const GET_MOREDRIVER_SUCCESS = "GET_MOREDRIVER_SUCCESS";
export const GET_MOREDRIVER_FAILED = "GET_MOREDRIVER_FAILED";

//FAQ Section Action
export const GET_FAQ_SECTION = "GET_FAQ_SECTION";
export const GET_FAQ_SECTION_REQUESTED = "GET_FAQ_SECTION_REQUESTED";
export const GET_FAQ_SECTION_SUCCESS = "GET_FAQ_SECTION_SUCCESS";
export const GET_FAQ_SECTION_FAILED = "GET_FAQ_SECTION_FAILED";
//Vehicle Action
export const GET_VEHICLE = "GET_VEHICLE";
export const GET_VEHICLE_REQUESTED = "GET_VEHICLE_REQUESTED";
export const GET_VEHICLE_SUCCESS = "GET_VEHICLE_SUCCESS";
export const GET_VEHICLE_FAILED = "GET_VEHICLE_FAILED";

//Create Vehicle Action
export const GET_ADDVEHICLE = "GET_ADDVEHICLE";
export const GET_ADDVEHICLE_REQUESTED = "GET_ADDVEHICLE_REQUESTED";
export const GET_ADDVEHICLE_SUCCESS = "GET_ADDVEHICLE_SUCCESS";
export const GET_ADDVEHICLE_FAILED = "GET_ADDVEHICLE_FAILED";

//Update Vehicle Action
export const GET_UPDATEVEHICLE = "GET_UPDATEVEHICLE";
export const GET_UPDATEVEHICLE_REQUESTED = "GET_UPDATEVEHICLE_REQUESTED";
export const GET_UPDATEVEHICLE_SUCCESS = "GET_UPDATEVEHICLE_SUCCESS";
export const GET_UPDATEVEHICLE_FAILED = "GET_UPDATEVEHICLE_FAILED";

//Delete VEHICLE Action
export const GET_DELETEVEHICLE = "GET_DELETEVEHICLE";
export const GET_DELETEVEHICLE_REQUESTED = "GET_DELETEVEHICLE_REQUESTED";
export const GET_DELETEVEHICLE_SUCCESS = "GET_DELETEVEHICLE_SUCCESS";
export const GET_DELETEVEHICLE_FAILED = "GET_DELETEVEHICLE_FAILED";

//Registration Action
export const GET_REGISTRATION = "GET_REGISTRATION";
export const GET_REGISTRATION_REQUESTED = "GET_REGISTRATION_REQUESTED";
export const GET_REGISTRATION_SUCCESS = "GET_REGISTRATION_SUCCESS";
export const GET_REGISTRATION_FAILED = "GET_REGISTRATION_FAILED";

//Our Car Action
export const GET_OURCAR = "GET_OURCAR";
export const GET_OURCAR_REQUESTED = "GET_OURCAR_REQUESTED";
export const GET_OURCAR_SUCCESS = "GET_OURCAR_SUCCESS";
export const GET_OURCAR_FAILED = "GET_OURCAR_FAILED";

//Cab Ride Details Action
export const GET_CABRIDE = "GET_CABRIDE";
export const GET_CABRIDE_REQUESTED = "GET_CABRIDE_REQUESTED";
export const GET_CABRIDE_SUCCESS = "GET_CABRIDE_SUCCESS";
export const GET_CABRIDE_FAILED = "GET_CABRIDE_FAILED";

//Top Vendor Action
export const GET_TOPVENDOR = "GET_TOPVENDOR";
export const GET_TOPVENDOR_REQUESTED = "GET_TOPVENDOR_REQUESTED";
export const GET_TOPVENDOR_SUCCESS = "GET_TOPVENDOR_SUCCESS";
export const GET_TOPVENDOR_FAILED = "GET_TOPVENDOR_FAILED";

//Top Sub Vendor Action
export const GET_TOPSUBVENDOR = "GET_TOPSUBVENDOR";
export const GET_TOPSUBVENDOR_REQUESTED = "GET_TOPSUBVENDOR_REQUESTED";
export const GET_TOPSUBVENDOR_SUCCESS = "GET_TOPSUBVENDOR_SUCCESS";
export const GET_TOPSUBVENDOR_FAILED = "GET_TOPSUBVENDOR_FAILED";

//Top Driver Action
export const GET_TOPDRIVER = "GET_TOPDRIVER";
export const GET_TOPDRIVER_REQUESTED = "GET_TOPDRIVER_REQUESTED";
export const GET_TOPDRIVER_SUCCESS = "GET_TOPDRIVER_SUCCESS";
export const GET_TOPDRIVER_FAILED = "GET_TOPDRIVER_FAILED";

//Ride Acceptance Action
export const GET_RIDEACCEPT = "GET_RIDEACCEPT";
export const GET_RIDEACCEPT_REQUESTED = "GET_RIDEACCEPT_REQUESTED";
export const GET_RIDEACCEPT_SUCCESS = "GET_RIDEACCEPT_SUCCESS";
export const GET_RIDEACCEPT_FAILED = "GET_RIDEACCEPT_FAILED";

//Dashboard Feedback Action
export const GET_DASHBOARDFEEDBACK = "GET_DASHBOARDFEEDBACK";
export const GET_DASHBOARDFEEDBACK_REQUESTED = "GET_DASHBOARDFEEDBACK_REQUESTED";
export const GET_DASHBOARDFEEDBACK_SUCCESS = "GET_DASHBOARDFEEDBACK_SUCCESS";
export const GET_DASHBOARDFEEDBACK_FAILED = "GET_DASHBOARDFEEDBACK_FAILED";

// Trip Action
export const GET_TRIP = "GET_TRIP";
export const GET_TRIP_REQUESTED = "GET_TRIP_REQUESTED";
export const GET_TRIP_SUCCESS = "GET_TRIP_SUCCESS";
export const GET_TRIP_FAILED = "GET_TRIP_FAILED";

// Invoice Details Action
export const GET_INVOICE = "GET_INVOICE";
export const GET_INVOICE_REQUESTED = "GET_INVOICE_REQUESTED";
export const GET_INVOICE_SUCCESS = "GET_INVOICE_SUCCESS";
export const GET_INVOICE_FAILED = "GET_INVOICE_FAILED";

// InvoiceDownlod Details Action
export const GET_INVOICE_DOWNLOAD = "GET_INVOICE_DOWNLOAD";
export const GET_INVOICE_DOWNLOAD_REQUESTED = "GET_INVOICE_DOWNLOAD_REQUESTED";
export const GET_INVOICE_DOWNLOAD_SUCCESS = "GET_INVOICE_DOWNLOAD_SUCCESS";
export const GET_INVOICE_DOWNLOAD_FAILED = "GET_INVOICE_DOWNLOAD_FAILED";

// Cancel Trip Action
export const GET_CANCEL_TRIP = "GET_CANCEL_TRIP";
export const GET_CANCEL_TRIP_REQUESTED = "GET_CANCEL_TRIP_REQUESTED";
export const GET_CANCEL_TRIP_SUCCESS = "GET_CANCEL_TRIP_SUCCESS";
export const GET_CANCEL_TRIP_FAILED = "GET_CANCEL_TRIP_FAILED";

//SOS Action
export const GET_SOS_ALERT = "GET_SOS_ALERT";
export const GET_SOS_ALERT_REQUESTED = "GET_SOS_ALERT_REQUESTED";
export const GET_SOS_ALERT_SUCCESS = "GET_SOS_ALERT_SUCCESS";
export const GET_SOS_ALERT_FAILED = "GET_SOS_ALERT_FAILED";

// Notification Action
export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const GET_NOTIFICATION_REQUESTED = "GET_NOTIFICATION_REQUESTED";
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS";
export const GET_NOTIFICATION_FAILED = "GET_NOTIFICATION_FAILED";

// Notification Count Action
export const GET_NOTIFICATIONCOUNT = "GET_NOTIFICATIONCOUNT";
export const GET_NOTIFICATIONCOUNT_REQUESTED = "GET_NOTIFICATIONCOUNT_REQUESTED";
export const GET_NOTIFICATIONCOUNT_SUCCESS = "GET_NOTIFICATIONCOUNT_SUCCESS";
export const GET_NOTIFICATIONCOUNT_FAILED = "GET_NOTIFICATIONCOUNT_FAILED";

// Notification Seen Action
export const GET_NOTIFICATIONSEEN = "GET_NOTIFICATIONSEEN";
export const GET_NOTIFICATIONSEEN_REQUESTED = "GET_NOTIFICATIONSEEN_REQUESTED";
export const GET_NOTIFICATIONSEEN_SUCCESS = "GET_NOTIFICATIONSEEN_SUCCESS";
export const GET_NOTIFICATIONSEEN_FAILED = "GET_NOTIFICATIONSEEN_FAILED";

// Request Assign Vehicle Action
export const GET_REQUESTVEHICLE = "GET_REQUESTVEHICLE";
export const GET_REQUESTVEHICLE_REQUESTED = "GET_REQUESTVEHICLE_REQUESTED";
export const GET_REQUESTVEHICLE_SUCCESS = "GET_REQUESTVEHICLE_SUCCESS";
export const GET_REQUESTVEHICLE_FAILED = "GET_REQUESTVEHICLE_FAILED";

// Assigned Vehicle Action
export const GET_LISTASSIGNEDVEHICLE = "GET_LISTASSIGNEDVEHICLE";
export const GET_LISTASSIGNEDVEHICLE_REQUESTED = "GET_LISTASSIGNEDVEHICLE_REQUESTED";
export const GET_LISTASSIGNEDVEHICLE_SUCCESS = "GET_LISTASSIGNEDVEHICLE_SUCCESS";
export const GET_LISTASSIGNEDVEHICLE_FAILED = "GET_LISTASSIGNEDVEHICLE_FAILED";

// List of Drivers Vehicle Action
export const GET_ASSIGNVEHICLE = "GET_ASSIGNVEHICLE";
export const GET_ASSIGNVEHICLE_REQUESTED = "GET_ASSIGNVEHICLE_REQUESTED";
export const GET_ASSIGNVEHICLE_SUCCESS = "GET_ASSIGNVEHICLE_SUCCESS";
export const GET_ASSIGNVEHICLE_FAILED = "GET_ASSIGNVEHICLE_FAILED";

// Update Assign Vehicle Action
export const GET_UPDATEASSIGNVEHICLE = "GET_UPDATEASSIGNVEHICLE";
export const GET_UPDATEASSIGNVEHICLE_REQUESTED = "GET_UPDATEASSIGNVEHICLE_REQUESTED";
export const GET_UPDATEASSIGNVEHICLE_SUCCESS = "GET_UPDATEASSIGNVEHICLE_SUCCESS";
export const GET_UPDATEASSIGNVEHICLE_FAILED = "GET_UPDATEASSIGNVEHICLE_FAILED";

//Update Assign Driver Action
export const GET_UPDATEASSIGNDRIVER = "GET_UPDATEASSIGNDRIVER";
export const GET_UPDATEASSIGNDRIVER_REQUESTED = "GET_UPDATEASSIGNDRIVER_REQUESTED";
export const GET_UPDATEASSIGNDRIVER_SUCCESS = "GET_UPDATEASSIGNDRIVER_SUCCESS";
export const GET_UPDATEASSIGNDRIVER_FAILED = "GET_UPDATEASSIGNDRIVER_FAILED";

//Update Assign SubVendor Action
export const GET_UPDATEASSIGNSUBVENDOR = "GET_UPDATEASSIGNSUBVENDOR";
export const GET_UPDATEASSIGNSUBVENDOR_REQUESTED = "GET_UPDATEASSIGNSUBVENDOR_REQUESTED";
export const GET_UPDATEASSIGNSUBVENDOR_SUCCESS = "GET_UPDATEASSIGNSUBVENDOR_SUCCESS";
export const GET_UPDATEASSIGNSUBVENDOR_FAILED = "GET_UPDATEASSIGNSUBVENDOR_FAILED";

//Choose Your Service Action
export const GET_CHOOSEYOURSERVICE = "GET_CHOOSEYOURSERVICE";
export const GET_CHOOSEYOURSERVICE_REQUESTED = "GET_CHOOSEYOURSERVICE_REQUESTED";
export const GET_CHOOSEYOURSERVICE_SUCCESS = "GET_CHOOSEYOURSERVICE_SUCCESS";
export const GET_CHOOSEYOURSERVICE_FAILED = "GET_CHOOSEYOURSERVICE_FAILED";

//Create Choose Your Service Action
export const GET_ADDCHOOSEYOURSERVICE = "GET_ADDCHOOSEYOURSERVICE";
export const GET_ADDCHOOSEYOURSERVICE_REQUESTED = "GET_ADDCHOOSEYOURSERVICE_REQUESTED";
export const GET_ADDCHOOSEYOURSERVICE_SUCCESS = "GET_ADDCHOOSEYOURSERVICE_SUCCESS";
export const GET_ADDCHOOSEYOURSERVICE_FAILED = "GET_ADDCHOOSEYOURSERVICE_FAILED";

//Update Choose Your Service Action
export const GET_UPDATECHOOSEYOURSERVICE = "GET_UPDATECHOOSEYOURSERVICE";
export const GET_UPDATECHOOSEYOURSERVICE_REQUESTED = "GET_UPDATECHOOSEYOURSERVICE_REQUESTED";
export const GET_UPDATECHOOSEYOURSERVICE_SUCCESS = "GET_UPDATECHOOSEYOURSERVICE_SUCCESS";
export const GET_UPDATECHOOSEYOURSERVICE_FAILED = "GET_UPDATECHOOSEYOURSERVICE_FAILED";

//Vehicle Matrix Action
export const GET_MATRIXVEHICLE = "GET_MATRIXVEHICLE";
export const GET_MATRIXVEHICLE_REQUESTED = "GET_MATRIXVEHICLE_REQUESTED";
export const GET_MATRIXVEHICLE_SUCCESS = "GET_MATRIXVEHICLE_SUCCESS";
export const GET_MATRIXVEHICLE_FAILED = "GET_MATRIXVEHICLE_FAILED";

//Vehicle More Details Action
export const GET_MOREVEHICLE = "GET_MOREVEHICLE";
export const GET_MOREVEHICLE_REQUESTED = "GET_MOREVEHICLE_REQUESTED";
export const GET_MOREVEHICLE_SUCCESS = "GET_MOREVEHICLE_SUCCESS";
export const GET_MOREVEHICLE_FAILED = "GET_MOREVEHICLE_FAILED";

//Get Rate Card Action
export const GET_RATECARD = "GET_RATECARD"
export const GET_RATECARD_REQUESTED = "GET_RATECARD_REQUESTED"
export const GET_RATECARD_SUCCESS = "GET_RATECARD_SUCCESS"
export const GET_RATECARD_FAILED = "GET_RATECARD_FAILED"

//Add Rate Card Action
export const GET_ADDRATECARD = "GET_ADDRATECARD"
export const GET_ADDRATECARD_REQUESTED = "GET_ADDRATECARD_REQUESTED"
export const GET_ADDRATECARD_SUCCESS = "GET_ADDRATECARD_SUCCESS"
export const GET_ADDRATECARD_FAILED = "GET_ADDRATECARD_FAILED"
 
// Add Service City Action
export const GET_SERVICECITY = "GET_SERVICECITY"
export const GET_SERVICECITY_REQUESTED = "GET_SERVICECITY_REQUESTED"
export const GET_SERVICECITY_SUCCESS = "GET_SERVICECITY_SUCCESS"
export const GET_SERVICECITY_FAILED = "GET_SERVICECITY_FAILED"

// Service Region Action
export const GET_SERVICEREGION = "GET_SERVICEREGION"
export const GET_SERVICEREGION_REQUESTED = "GET_SERVICEREGION_REQUESTED"
export const GET_SERVICEREGION_SUCCESS = "GET_SERVICEREGION_SUCCESS"
export const GET_SERVICEREGION_FAILED = "GET_SERVICEREGION_FAILED"

//Add Service Region Action
export const GET_ADDSERVICEREGION = "GET_ADDSERVICEREGION";
export const GET_ADDSERVICEREGION_REQUESTED = "GET_ADDSERVICEREGION_REQUESTED";
export const GET_ADDSERVICEREGION_SUCCESS = "GET_ADDSERVICEREGION_SUCCESS";
export const GET_ADDSERVICEREGION_FAILED = "GET_ADDSERVICEREGION_FAILED";

//Create Sub-vendor Region Action
export const GET_SUBVENDORREGION = "GET_SUBVENDORREGION";
export const GET_SUBVENDORREGION_REQUESTED = "GET_SUBVENDORREGION_REQUESTED";
export const GET_SUBVENDORREGION_SUCCESS = "GET_SUBVENDORREGION_SUCCESS";
export const GET_SUBVENDORREGION_FAILED = "GET_SUBVENDORREGION_FAILED";

//Add sub-vendor Region Action
export const GET_ADDSUBVENDORREGION = "GET_ADDSUBVENDORREGION";
export const GET_ADDSUBVENDORREGION_REQUESTED = "GET_ADDSUBVENDORREGION_REQUESTED";
export const GET_ADDSUBVENDORREGION_SUCCESS = "GET_ADDSUBVENDORREGION_SUCCESS";
export const GET_ADDSUBVENDORREGION_FAILED = "GET_ADDSUBVENDORREGION_FAILED";

//Get Vendor user Action
export const GET_VENDORUSER = "GET_VENDORUSER";
export const GET_VENDORUSER_REQUESTED = "GET_VENDORUSER_REQUESTED";
export const GET_VENDORUSER_SUCCESS = "GET_VENDORUSER_SUCCESS";
export const GET_VENDORUSER_FAILED = "GET_VENDORUSER_FAILED";

//Logout Action
export const GET_LOGOUT = "GET_LOGOUT";
export const GET_LOGOUT_REQUESTED = "GET_LOGOUT_REQUESTED";
export const GET_LOGOUT_SUCCESS = "GET_LOGOUT_SUCCESS";
export const GET_LOGOUT_FAILURE = "GET_LOGOUT_FAILURE";

//Get Assign Driver Action
export const GET_ASSIGN_DRIVER = "GET_ASSIGN_DRIVER";
export const GET_ASSIGN_DRIVER_REQUESTED = "GET_ASSIGN_DRIVER_REQUESTED";
export const GET_ASSIGN_DRIVER_SUCCESS = "GET_ASSIGN_DRIVER_SUCCESS";
export const GET_ASSIGN_DRIVER_FAILED = "GET_ASSIGN_DRIVER_FAILED";

//Get Booking Action
export const GET_BOOKING = "GET_BOOKING";
export const GET_BOOKING_REQUESTED = "GET_BOOKING_REQUESTED";
export const GET_BOOKING_SUCCESS = "GET_BOOKING_SUCCESS";
export const GET_BOOKING_FAILED = "GET_BOOKING_FAILED";

//Get Base Fuel Action
export const GET_BASE_FUEL = "GET_BASE_FUEL";
export const GET_BASE_FUEL_REQUESTED = "GET_BASE_FUEL_REQUESTED";
export const GET_BASE_FUEL_SUCCESS = "GET_BASE_FUEL_SUCCESS";
export const GET_BASE_FUEL_FAILED = "GET_BASE_FUEL_FAILED";

//Magic Token Action
export const GET_MAGICTOKEN = "GET_MAGICTOKEN";
export const GET_MAGICTOKEN_REQUESTED = "GET_MAGICTOKEN_REQUESTED";
export const GET_MAGICTOKEN_SUCCESS = "GET_MAGICTOKEN_SUCCESS";
export const GET_MAGICTOKEN_FAILED = "GET_MAGICTOKEN_FAILED";

//Magic Token Verifiy Action
export const GET_TOKENVERIFY = "GET_TOKENVERIFY";
export const GET_TOKENVERIFY_REQUESTED = "GET_TOKENVERIFY_REQUESTED";
export const GET_TOKENVERIFY_SUCCESS = "GET_TOKENVERIFY_SUCCESS";
export const GET_TOKENVERIFY_FAILED = "GET_TOKENVERIFY_FAILED";

// Reservation Details
export const GET_RESERVATIONDETAILS = {
  GET_RESERVATIONDETAILS_REQUESTED: "GET_RESERVATIONDETAILS_REQUESTED",
  GET_RESERVATIONDETAILS_SUCCESS: "GET_RESERVATIONDETAILS_SUCCESS",
  GET_RESERVATIONDETAILS_FAILED: "GET_RESERVATIONDETAILS_FAILED",
  CLEAR_RESERVATIONDETAILS: "CLEAR_RESERVATIONDETAILS"
};